<template>
    <div class="g-content admire">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="任务广场" name="playgroundPage">
                <playground-page></playground-page>
            </el-tab-pane>
            <el-tab-pane label="我的任务" name="personPage">
                <person-page></person-page>
            </el-tab-pane>
            <el-tab-pane label="数据统计" name="dataPage">
                <data-page></data-page>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<style>
.admire .el-tabs .el-tabs__item {
    font-size: 16px;
}
</style>

<style lang="scss" scoped>
@import '~Assets/sass/pages/v4/admire/index.scss';
</style>
<script>

import playgroundPage from './_playground.vue';
import personPage from './_person.vue';
import dataPage from './_data.vue';
export default {
    data() {
        return {
            activeName: 'playgroundPage'
        };
    },
    components: {
        playgroundPage,
        personPage,
        dataPage
    },
    mounted() {
        console.log('manage');
        if (this.$route.query.type) {
            this.activeName = this.$route.query.type;
        }
    },
    methods: {
        handleClick(e) {
            //e.name
        }
    }
}
</script>
